import React, { useState } from "react";
import styles from "./PDO.module.css";
import CellModel from "./CellModel";
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

// 면역세포·CAF 그룹 (2026-11-05).
// 뱅킹 Key 10번째 글자 B=PBMC · L=TIL · C=CAF. Organoid_Info 행이 없어 PDO 목록과 따로 보여준다.
const CELL_TYPES = ['PBMC', 'TIL', 'CAF'];

function CellModels({ num, search }) {
    const [visible, setVisible] = useState(false);
    const checkZero = (n) => (n === 0 || !n ? '' : `(${n})`);

    return (
        <>
            <div className={styles.title} onClick={() => setVisible(!visible)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img
                        className={visible ? styles.minusImg : styles.plusImg}
                        src={visible ? downTriangleIcon : sideTriangleIcon}
                        alt="toggleIcon"
                    />
                </span>
                <span className={styles.pdoModels}>Immune Cells / CAF</span>
                <span className={styles.PDOnumber}>{checkZero(num?.num)}</span>
            </div>
            {visible && (
                <div className={styles.pdoBox}>
                    {CELL_TYPES.map((name) => (
                        <CellModel name={name} search={search} key={`cell-model-${name}`} />
                    ))}
                </div>
            )}
        </>
    );
}

export default CellModels;
